import { APP } from '../config/app';

export const buildWhatsappUrl = (message) => {
  const text = encodeURIComponent(message);
  return `https://wa.me/${APP.supportWhatsapp}?text=${text}`;
};

export const openWhatsappSupport = (message) => {
  window.open(buildWhatsappUrl(message), '_blank', 'noopener,noreferrer');
};

export const callSupport = () => {
  window.open(`tel:+${APP.supportPhone}`, '_self');
};

export const buildRiderHelpMessage = (riderName) => {
  return [
    'Hi MyTownly, I need help as a delivery partner.',
    riderName ? `Rider: ${riderName}` : null,
    `Area: ${APP.town}`,
  ].filter(Boolean).join('\n');
};
